import React from 'react'

interface IconProps {
  className?: string
  'aria-hidden'?: boolean
}

export const MessageIcon: React.FC<IconProps> = ({ className, ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path 
      d="M4 6a4 4 0 0 1 4-4h7.343a4 4 0 0 1 2.829 1.172l2.656 2.656A4 4 0 0 1 22 8.657V18a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V6Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinejoin="round"
    />
    <path 
      d="M9 7h8m-8 5h8m-8 5h4" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round"
    />
  </svg>
)